// Uberflip Outsource OB-10330 start here
const handleDescriptionPositioning = () => {
    setTimeout(() => {
        if (!window.obData || !window.obData.bLDescriptionStreams) {
            return;
        }
    
        if(window.obData.bLDescriptionStreams) {
            
            const body = document.querySelector('body').classList;
            const streamPageID = document.getElementById('page-type-identifier').dataset.collectionId;
    
            if(body.contains('uf-stream-template-banner') && window.obData.bLDescriptionStreams.includes(streamPageID)) {

                const descriptionBlock = document.querySelector('.page-aligner .description-block p');
                const heading = document.querySelector('.stream-banner-heading');
                const bannerContent = document.querySelector('#top-header .stream-banner-content');

                if (heading && descriptionBlock && bannerContent) {
                    const headingColor = window.getComputedStyle(heading).color;
                    descriptionBlock.style.color = headingColor;
                    bannerContent.appendChild(descriptionBlock);
                    descriptionBlock.classList.add('stream-banner-description');
                }
            }
        }
    }, 2);
};

export { handleDescriptionPositioning };
// Uberflip Outsource OB-10330 end here



// WEBPACK FOOTER //
// ./scriptPartials/handleDescriptionPositioning.js